import React from "react";
import LegalDocument from "@/components/LegalDocument";

export default function PrivacyPolicy() {
  return (
    <LegalDocument
      titleKey="privacyTitle"
      docKey="privacy"
      testId="legal-privacy-page"
    />
  );
}
